module.exports = __webpack_public_path__ + "media/images/icon__infoBox--rb-gray-db27edc888abbea5df4a94fbe0bc8b5e.png";